import ColorService from '@services/color'
import { $cssVariables, $cssVariablesLikeCssRoot } from './state'
import { CssVariables } from './types'

class CssVariablesService {
  static variables(): CssVariables {
    return $cssVariables.getState()
  }

  static likeCssRoot(): string {
    return $cssVariablesLikeCssRoot.getState()
  }

  static findVariable(key: keyof CssVariables): string {
    return $cssVariables.getState()[key]
  }

  static get mainColor(): string {
    return CssVariablesService.findVariable('--color1')
  }

  static animationSpeed(asNumber: false): string
  static animationSpeed(asNumber: true): number
  static animationSpeed(asNumber = false) {
    const value = CssVariablesService.findVariable('--animation-speed')

    return asNumber ? parseInt(value) : value
  }

  static toRGBA(key: keyof CssVariables, opacity: number): string {
    const color = $cssVariables.getState()[key]

    return ColorService(color).alpha(opacity).toString()
  }
}

export default CssVariablesService
